"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _antd = require("antd");

var _icons = require("@ant-design/icons");

var _EllipsisDropdown = _interopRequireDefault(require("../../../../../components/shared-components/EllipsisDropdown"));

var _Flex = _interopRequireDefault(require("../../../../../components/shared-components/Flex"));

var _utils = _interopRequireDefault(require("../../../../../utils"));

var _moreTableData = _interopRequireDefault(require("./moreTableData"));

var _editDetails = _interopRequireDefault(require("./../editDetails"));

var _reactCsv = require("react-csv");

var _config = _interopRequireDefault(require("../../../../../config.json"));

var _axios = _interopRequireDefault(require("axios"));

var Option = _antd.Select.Option;
var header = [{
  label: "CL_code",
  key: "CL_code"
}, {
  label: "RM_code",
  key: "RM_code"
}, {
  label: "Token_no",
  key: "Token_no"
}, {
  label: "Student_name",
  key: "Student_name"
}, {
  label: "Parent_status",
  key: "Parent_status"
}, {
  label: "Subject",
  key: "Subject"
}, {
  label: "WhatsApp_no",
  key: "WhatsApp_no"
}, {
  label: "DOB",
  key: "DOB"
}, {
  label: "Joining_date",
  key: "Joining_date"
}, {
  label: "School_type",
  key: "School_type"
}, {
  label: "School_fee",
  key: "School_fee"
}, {
  label: "Class",
  key: "Class"
}, {
  label: "Calling_no",
  key: "Calling_no"
}, {
  label: "English_label",
  key: "English_label"
}, {
  label: "English_worsheet_no",
  key: "English_worsheet_no"
}, {
  label: "Label",
  key: "Label"
}, {
  label: "Address",
  key: "Address"
}, {
  label: "Maths_Mode_status",
  key: "Mode_status"
}, {
  label: "English_mode_status",
  key: "English_mode_status"
}];
var allTokens = [];

var TableData = function TableData(_ref) {
  var data = _ref.data;
  var date = new Date();
  var today = "".concat(date.getFullYear(), "-").concat(date.getMonth() + 1, "-").concat(date.getDate());
  var time = "".concat(date.getHours(), ":").concat(date.getMinutes());
  var csvRport = {
    filename: "\"Parent Data\"+\" \"+".concat(today, "+\" \"+").concat(time),
    headers: header,
    data: data
  };

  var _useState = (0, _react.useState)(true),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var cl = localStorage.getItem("CL");
  var token = localStorage.getItem("token"); // eslint-disable-next-line

  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      apiError = _useState4[0],
      setapiError = _useState4[1];

  var _useState5 = (0, _react.useState)(data),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      tableData = _useState6[0],
      setTableData = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      edit = _useState8[0],
      setEdit = _useState8[1];

  var _useState9 = (0, _react.useState)({}),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      editDetail = _useState10[0],
      setEditDetail = _useState10[1];

  var _useState11 = (0, _react.useState)([]),
      _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
      allRM = _useState12[0],
      setAllRM = _useState12[1];

  var _useState13 = (0, _react.useState)(""),
      _useState14 = (0, _slicedToArray2.default)(_useState13, 2),
      column = _useState14[0],
      setColumn = _useState14[1];

  var _useState15 = (0, _react.useState)(""),
      _useState16 = (0, _slicedToArray2.default)(_useState15, 2),
      value = _useState16[0],
      setValue = _useState16[1];

  var SubjectList = ['Math', 'English', 'Both']; // eslint-disable-next-line

  var _useState17 = (0, _react.useState)([]),
      _useState18 = (0, _slicedToArray2.default)(_useState17, 2),
      filterRM = _useState18[0],
      setFilterRM = _useState18[1];

  var _useState19 = (0, _react.useState)(false),
      _useState20 = (0, _slicedToArray2.default)(_useState19, 2),
      visible = _useState20[0],
      setVisible = _useState20[1];

  var getSubjectsStatus = function getSubjectsStatus(status) {
    if (status === 'Math') {
      return 'success';
    }

    if (status === 'English') {
      return 'warning';
    }

    if (status === 'Both') {
      return 'error';
    }

    return '';
  };

  var columns = [{
    title: "Joining Date",
    dataIndex: "Joining_date",
    key: "Joining_date",
    fixed: "left",
    sorter: function sorter(a, b) {
      return _utils.default.antdTableSorter(a, b, 'Joining_date');
    }
  }, {
    title: "RM Code",
    dataIndex: "RM_code",
    key: "RM_code",
    fixed: "left",
    sorter: function sorter(a, b) {
      return _utils.default.antdTableSorter(a, b, 'RM_code');
    }
  }, {
    title: "Token No",
    dataIndex: "Token_no",
    key: "Token_no",
    fixed: "left",
    sorter: function sorter(a, b) {
      return _utils.default.antdTableSorter(a, b, 'Token_no');
    }
  }, {
    title: "Student Name",
    dataIndex: "Student_name",
    key: "Student_name",
    fixed: "left",
    sorter: function sorter(a, b) {
      return _utils.default.antdTableSorter(a, b, 'Student_name');
    }
  }, {
    title: "Subjects",
    dataIndex: "Subject",
    key: "Subject",
    fixed: "left",
    render: function render(_, record) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_antd.Badge, {
        status: getSubjectsStatus(record.Subject)
      }), /*#__PURE__*/_react.default.createElement("span", null, record.Subject));
    },
    sorter: function sorter(a, b) {
      return _utils.default.antdTableSorter(a, b, 'Subject');
    }
  }, {
    title: "Whatsapp Number",
    dataIndex: "WhatsApp_no",
    key: "WhatsApp_no",
    fixed: "left",
    sorter: function sorter(a, b) {
      return _utils.default.antdTableSorter(a, b, 'WhatsApp_no');
    }
  }, {
    title: 'Action',
    dataIndex: 'actions',
    fixed: "left",
    render: function render(_, elm) {
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_EllipsisDropdown.default, {
        menu: dropdownMenu(elm)
      }));
    }
  }, {
    title: 'check',
    dataIndex: 'RM_code',
    fixed: "left",
    render: function render(_, elm) {
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_antd.Checkbox, {
        onClick: function onClick() {
          return getData(elm);
        }
      }));
    }
  }]; // useEffect(async()=>{
  //         setTableData(data);
  //         setLoading(false)
  // },[data]);

  (0, _react.useEffect)(function () {
    function fatchData() {
      return _fatchData.apply(this, arguments);
    }

    function _fatchData() {
      _fatchData = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var allRMUrl;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                setTableData(data);
                setLoading(false);
                allRMUrl = _config.default.listOfRMs + cl;

                _axios.default.get(allRMUrl, {
                  headers: {
                    'Authorization': token
                  }
                }).then(function (resp) {
                  if (resp.data.status === "error") setapiError(resp.data);else {
                    setAllRM(resp.data);
                    setFilterRM(resp.data);
                    setLoading(false);
                  }
                }, function (err) {
                  var obj = {
                    "status": "error",
                    "message": "Network Error"
                  };
                  if (err.response) setapiError(err.response);else setapiError(obj);
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _fatchData.apply(this, arguments);
    }

    fatchData(); // eslint-disable-next-line 
  }, [data]);

  var dropdownMenu = function dropdownMenu(elm) {
    return /*#__PURE__*/_react.default.createElement(_antd.Menu, null, /*#__PURE__*/_react.default.createElement(_antd.Menu.Item, null, /*#__PURE__*/_react.default.createElement(_Flex.default, {
      alignItems: "center"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "ml-2",
      onClick: function onClick() {
        return EditStudent(elm);
      }
    }, /*#__PURE__*/_react.default.createElement(_icons.EditOutlined, {
      className: "mr-1"
    }), "Edit"))));
  };

  var EditStudent = function EditStudent(ele) {
    setEditDetail(ele);
    setEdit(true);
  };

  var getData = function getData(elm) {
    if (allTokens.includes(elm)) {
      allTokens.splice(allTokens.indexOf(elm), 1);
    } else {
      allTokens.push(elm);
    }

    console.log(allTokens);

    if (allTokens.length !== 0) {
      document.getElementById("edit_bulk").style.display = "block";
    } else {
      document.getElementById("edit_bulk").style.display = "none";
    }
  };

  var showModal = function showModal() {
    setVisible(true);
  };

  var handleOk = function handleOk() {
    var data = {
      "status": column,
      "value": value,
      "allData": allTokens
    };
    console.log(data);
    var url = _config.default.updateBulkStudent;

    _axios.default.post(url, data, {
      headers: {
        'Authorization': token
      }
    }).then(function (resp) {
      if (resp.data.status === "error") setapiError(resp.data);
      alert("Updated Successfully");
      window.location = '/clPortal/app/parent/allparent';
    }, function (err) {
      var obj = {
        "status": "error",
        "message": "Network Error"
      };
      if (err.response) setapiError(err.response);else setapiError(obj);
    });
  };

  var handleCancel = function handleCancel() {
    setVisible(false);
  };

  var handleShowRM = function handleShowRM(value) {
    setValue(value);
  };

  var handleShowSubject = function handleShowSubject(value) {
    setValue(value);
  };

  var handleBulkEditMainSelect = function handleBulkEditMainSelect(value) {
    setColumn(value);

    if (value === "RM_code") {
      document.getElementById("subject_select").style.display = "none";
      document.getElementById("rm_select").style.display = "block";
    } else if (value === "Subject") {
      document.getElementById("rm_select").style.display = "none";
      document.getElementById("subject_select").style.display = "block";
    } else {
      setValue("Drop Out");
      document.getElementById("rm_select").style.display = "none";
      document.getElementById("subject_select").style.display = "none";
    }
  };

  return loading ? /*#__PURE__*/_react.default.createElement(_antd.Spin, {
    tip: "loading"
  }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_antd.Card, {
    title: "Active Students",
    style: {
      'fontSize': '5px'
    },
    extra: /*#__PURE__*/_react.default.createElement(_reactCsv.CSVLink, csvRport, /*#__PURE__*/_react.default.createElement(_icons.DownloadOutlined, {
      style: {
        'fontSize': 30
      }
    }))
  }, /*#__PURE__*/_react.default.createElement(_antd.Button, {
    className: "Edit-open",
    type: "primary",
    onClick: function onClick() {
      return showModal();
    },
    id: "edit_bulk",
    style: {
      display: "none"
    }
  }, "Edit"), /*#__PURE__*/_react.default.createElement(_antd.Table, {
    xs: 24,
    sm: 50,
    md: 50,
    columns: columns,
    dataSource: tableData,
    rowKey: "Token_no",
    expandable: {
      expandedRowRender: function expandedRowRender(record) {
        return /*#__PURE__*/_react.default.createElement(_moreTableData.default, {
          record: record
        });
      }
    }
  }), /*#__PURE__*/_react.default.createElement(_antd.Modal, {
    title: "Edit Here",
    visible: visible,
    onOk: function onOk() {
      return handleOk();
    },
    onCancel: function onCancel() {
      return handleCancel();
    }
  }, /*#__PURE__*/_react.default.createElement(_antd.Select, {
    onChange: handleBulkEditMainSelect,
    style: {
      width: 200
    },
    placeholder: "Select option"
  }, /*#__PURE__*/_react.default.createElement(Option, {
    value: "RM_code"
  }, "RM Code"), /*#__PURE__*/_react.default.createElement(Option, {
    value: "Subject"
  }, "Subject"), /*#__PURE__*/_react.default.createElement(Option, {
    value: "Parent_status"
  }, "Dropout")), /*#__PURE__*/_react.default.createElement("div", {
    id: "rm_select",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/_react.default.createElement(_antd.Select, {
    showSearch: true,
    style: {
      width: '90%'
    },
    placeholder: "Search or Select RM Code",
    optionFilterProp: "children",
    filterOption: function filterOption(input, option) {
      return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    filterSort: function filterSort(optionA, optionB) {
      return optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase());
    },
    onChange: handleShowRM
  }, /*#__PURE__*/_react.default.createElement(Option, {
    value: "All"
  }, "All"), allRM.map(function (item) {
    return /*#__PURE__*/_react.default.createElement(Option, {
      key: item,
      value: item
    }, item);
  }))), /*#__PURE__*/_react.default.createElement("div", {
    id: "subject_select",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/_react.default.createElement(_antd.Select, {
    placeholder: "Select Subject",
    style: {
      width: '90%'
    },
    onChange: handleShowSubject
  }, SubjectList.map(function (elm) {
    return /*#__PURE__*/_react.default.createElement(Option, {
      key: elm,
      value: elm
    }, elm);
  }))))), edit ? /*#__PURE__*/_react.default.createElement(_editDetails.default, {
    onCancel: function onCancel() {
      return setEdit(false);
    },
    item: editDetail,
    showEdit: edit
  }) : "");
};

var _default = TableData;
exports.default = _default;